import { render, staticRenderFns } from "./ManageLicensesPage.vue?vue&type=template&id=56cc6c6c&"
import script from "./ManageLicensesPage.vue?vue&type=script&lang=js&"
export * from "./ManageLicensesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports